import { createSelector } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import * as documentChecklistReducer from './document-checklist.reducer';

export const getState = (state: {
    documentChecklist: documentChecklistReducer.State;
}): documentChecklistReducer.State => state.documentChecklist;

export const getDocumentRequirementsIsLoading = (props: {
    entityId: string;
    entityType: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: documentChecklistReducer.State) =>
            state.documentRequirements[props.entityType][props.entityId]
                ?.isLoadingList,
    );

export const getDocumentRequirementsHasError = (props: {
    entityId: string;
    entityType: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: documentChecklistReducer.State) =>
            state.documentRequirements[props.entityType][props.entityId]
                ?.hasLoadingListError,
    );

export const getDocumentRequirementsFilteredList = createSelector(
    getState,
    (state: documentChecklistReducer.State, props: any) =>
        state.documentRequirements[props.id]?.filteredList,
);

export const getDocumentRequirements = createSelector(
    getState,
    (
        state: documentChecklistReducer.State,
        props: {
            entityId: string;
            entityType: SystemEntity;
        },
    ) => {
        return state.documentRequirements[props.entityType]
            ? state.documentRequirements[props.entityType][props.entityId]?.list
            : null;
    },
);

export const getDocumentRequirementTypes = createSelector(
    getState,
    (state: documentChecklistReducer.State) =>
        state.documentRequirementTypes?.list,
);
